import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";

import AddSlideNewIcon from "../../images/AddSlideNewIcon.svg";
// import { getEdtailData, removeEdtailData } from "../../utils";
import "../../css/editor.scss";
import ValueContext from "../../utils/contextAPI/contextAPI";
import {
  createNewPage,
  createNewPageUpdate,
  createNewChildSlide,
  AddMasterSlideToDeck,
  updatSlideData,
} from "../../services/apis";
import {
  addNewChildSlide,
  navigateToPrevChildAndParent,
  navigateToNextChildAndFromParent,
  inParent,
  lastChild,
} from "./ChildSlideCrND";
import { toggleLeftPanel } from "../../utils/editorUtils/commonFunctions";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
import { thirdPartyPlugins } from "../../utils/editorUtils/editorUtils";

const SlideIndex = ({
  slideCount,
  setSlideCount,
  currentSlide,
  setCurrentSlide,
  setSlideID,
  slideID,
  editor,
  slideNameCount,
  setSlideNameCount,
  geteDetailByID,
  childSlideCount,
  setChildSlideCount,
  inputElement,
  setcanvasWidth,
  loadSuccess,
  setLoadSuccess,
  setSaveLoading,
  setOpenPopover,
}) => {
  const appData = useContext(ValueContext);

  const formatCommonHtml = () => {
    //chngs made for commonhyml
    const comp = editor?.getWrapper().find("[commonHtml]");
    const allComp =
      editor.getWrapper().attributes?.components?.models[0]?.attributes
        .components.models;
    const copy = allComp; //JSON.parse(JSON.stringify(allComp));
    // console.log(
    //   comp,
    //   copy,
    //   editor.DomComponents.getComponents(),
    //   "non common >>>>>>>>>>>>>>>>>>>>>>>>>>>>>"
    // );
    let html = "";
    let cssString = "";
    for (var i = 0; i < comp.length; i++) {
      
      html += comp[i].toHTML();
      //cssString += comp[i].toCSS;
      // console.log(html, comp[i].getStyle(), "html>>>>>>>>>>>>>>>>>>>>>>");
      // console.log('for of slide >>>>>>>>>>>>>>>>>>>>>>>>>>',copy[i], copy[i]?.attributes.attributes.hasOwnProperty('commonHtml') )
     
    }
    const projectData = editor.getProjectData();
    const onlyCommon = projectData?.pages[0].frames[0]?.component?.components[0]?.components?.filter(element =>
      {if (element.hasOwnProperty('attributes')) {
      return element?.attributes['commonHtml'] == true
      }}
       
     );
    projectData.pages[0].frames[0].component.components[0].components = [] ;
    projectData?.pages[0].frames[0]?.component?.components[0]?.components?.push(...onlyCommon);
    let payload = {
      editorData: JSON.stringify(projectData) || "",
      html: html || '', //editor.getHtml() || "",
      css: editor.getCss() || "",
      scripts: "",
      thirdPartyPlugins: thirdPartyPlugins,
      //components: comp, // editor.getComponents() || "",
     // styles: editor.getStyle() || "",
    };
    // console.log("creatio of slide >>>>>>>>>>>>>>>>>>>>>>>>>>", payload, editor.getProjectData(), projectData, onlyCommon);
    return payload;
  };

  let navigate = useNavigate();
  const { pageId } = useParams();
  const [enableAdd, setEnableAdd] = useState(true);

  const addNewPage = async (origin) => {
    //chngs made for commonhyml
    /* const comp =  editor
              ?.getWrapper()
      .find("[nonCommonHtml]");    
    var allComp = editor.getComponents();
    console.log(comp, allComp,  "non common >>>>>>>>>>>>>>>>>>>>>>>>>>>>>")     
    /* for (var i = 0; i < comp.length; i++){
      if (comp[i].getAttributes().hasOwnProperty('commonHtml') && comp[i].attributes.name === "Wrapper") {
        return;
       }else
       allComp.remove(comp[i]);
    }  */
    /*let payload = {
      editorData: "",
      html: editor.getHtml() || "",
      css: editor.getCss() || "",
      components: editor.getComponents() || "",
      styles: editor.getStyle() || "",
    };
    console.log('creatio of slide >>>>>>>>>>>>>>>>>>>>>>>>>>', payload ) */
    if (slideID.length === 999) {
      showErrorToast('Limit Exceeded');
      return;
    }
    if (!loadSuccess) return;

    setLoadSuccess(false);
    setSaveLoading(true);

    // setEnableAdd(false);
    if (!enableAdd) return;
    let newSlideIndex = currentSlide?.master?.index;

    // let deckFromBackend = {};
    // savePage(editor, currentSlide);
    // await geteDetailByID(
    //   appData.deckId._id,
    //   async (response, err, errorCode) => {
    //     if (err) {
    //     } else {
    //       deckFromBackend = await response.data;
    //       // appData.setDeckId(data); to avoid unnecessary rerender
    //     }
    //   }
    // );

    const createNewPagePaload = {
      // name: appData.deckId.name + "_" + new Date().getTime(),
      name: appData.deckId.name.substring(0, 10) + "_" + new Date().getTime(),

      // name:
      //   appData.deckId.name +
      //   "_" +
      //   (currentSlide?.master?.index + 1) +
      //   "_" +
      //   new Date().getTime(),
      // name: appData.deckId.name + "-Slide_" + (currentSlide?.master?.index + 1),
      desc: appData.deckId.desc,
      content: {},//formatCommonHtml() || {},
      thumbnail: appData.deckId.thumbnail || "https://cdn.link/image.png",
      tags: appData.deckId.tags,
      key_message: "Enter Key Message",
      member_of: [appData.deckId],
    };
    // const getCurrentSlideIndex = () => {
    //   return slideID.findIndex(
    //     (slide) => slide.slideid._id === currentSlide.master.slideid._id
    //   );
    // };

    createNewPage(createNewPagePaload, (response, err, errorCode) => {
      const defaultErr = "Master Slide creation failed. Pl try again";
      if (err) {
        if (errorCode === 400) {
          showErrorToast(err?.response?.data?.error || defaultErr);
        } else
          showErrorToast(defaultErr);
        setSaveLoading(false);
        setLoadSuccess(true);
        return;
      } else {
       toggleLeftPanel();
        showSuccessToast('Master Slide creation successful');
        setSaveLoading(false);
        setOpenPopover(false);
        // setIsloading(false);
        const data = response.data;
        // let newSlideIndex = index() + 1;

        const pagePatchPayload = {
          slides: [
            {
              index: newSlideIndex + 1, //insert at next to current slide
              slideid: data._id,
              children: [],
            },
          ],
        };
        // let index = deckFromBackend.slides.length + 1;
        let tempSlideID = JSON.parse(JSON.stringify(slideID));
        tempSlideID.splice(newSlideIndex, 0, {
          //index:index
          index: newSlideIndex + 1,
          slideid: {
            name: data.name,
            key_message: "Enter Key Message", //bcs data.key_message is an ""
            _id: data._id,
            thumbnail: data?.thumbnail,
          },
          children: [],
        });
        let newSlideIndexVal = newSlideIndex + 1;
        if (newSlideIndexVal < tempSlideID.length) {
          for (let i = newSlideIndexVal; i < tempSlideID.length; i++) {
            tempSlideID[i].index = i + 1;
          }
        }
        setSlideID(tempSlideID);
        setSlideCount(newSlideIndex + 1);
        updatePatchApi(pagePatchPayload, data._id, data, newSlideIndex);
        // setCurrentSlide({
        //   master: {
        //     //index: index,
        //     index: newSlideIndex + 1,
        //     slideid: {
        //       name: data.name,
        //       key_message: data.key_message,
        //       _id: data._id,
        //       thumbnail: data.thumbnail,
        //     },
        //     children: [],
        //   },
        //   child: {},
        // });
        // setSlideNameCount(slideNameCount + 1);

        // // setEnableAdd(true);
        // saveContentWhencrated(data._id);
      }
    });
  };

  const updatePatchApi = (payload, newSlideId, data, newSlideIndex) => {
    createNewPageUpdate(
      appData.deckId._id,
      payload,
      (response, err, errorCode) => {
        if (err) {
          //error handle
        } else {
          // console.log(response, "responsePatch"); // here we get slides

          setCurrentSlide({
            master: {
              //index: index,
              index: newSlideIndex + 1,
              slideid: {
                name: data.name,
                key_message: data.key_message,
                _id: data._id,
                thumbnail: data.thumbnail,
              },
              children: [],
            },
            child: {},
          });
          setSlideNameCount(slideNameCount + 1);

          // setEnableAdd(true);
          saveContentWhencrated(data._id);
          navigate(`/editor/${newSlideId}`, { replace: true });
        }
      }
    );
  };

  const saveContentWhencrated = (newSlideId) => {
    let payload = {
      editorData: "",
      html: editor.getHtml() || "",
      css: editor.getCss() || "",
      components: editor.getComponents() || "",
      styles: editor.getStyle() || "",
    };
    /* console.log("slide data return", payload) */ //chngs made for commonhyml
    updatSlideData(newSlideId, payload, (response, err, errorCode) => {
      if (err) {
      } else {
        // console.log(response, "responsePatch"); // here we get slides
      }
    });
  };
  return (
    <div onClick={() => addNewPage()} className="parent-Slide">
      <img src={AddSlideNewIcon} alt="" />
      <h2>Slide</h2>
    </div>
    // <div className="new-slide-Container">
    //   {JSON.stringify(currentSlide.child) === "{}" ? (
    //     <>
    //       <div></div>
    //       <div className="new-slide">
    //         <ul>
    //           <li
    //             className=""
    //             style={{ cursor: "pointer" }}
    //             onClick={() => addNewPage()}
    //           >
    //             <img
    //               src={NewSlideAddDocumentIcon}
    //               title="New Slide"
    //               alt="New Slide"
    //               style={{ cursor: "pointer" }}
    //             />
    //           </li>
    //           <li>
    //             <img
    //               src={NewSlideGroupIcon}
    //               style={{ cursor: "pointer" }}
    //               alt=""
    //             />
    //           </li>
    //         </ul>
    //       </div>
    //     </>
    //   ) : (
    //     <div></div>
    //   )}
    //   <div className="arrows-right-down">
    //     <ul>
    //       <li>
    //         <img
    //           src={NewSlideLeftArrowIcon}
    //           // className="up-arrow"
    //           className={
    //             inParent(currentSlide) ? "up-arrow-disabled" : "up-arrow"
    //           }
    //           style={{ cursor: "pointer" }}
    //           alt=""
    //           onClick={() => {
    //             !inParent(currentSlide) &&
    //               navigateToPrevChildAndParent(
    //                 currentSlide,
    //                 setCurrentSlide,
    //                 setChildSlideCount,
    //                 setSlideCount,
    //                 editor,
    //                 navigate,
    //                 slideID,
    //                 setSlideID,
    //                 inputElement,
    //                 setcanvasWidth,
    //                 setLoadSuccess,
    //                 setSaveLoading,
    //                 loadSuccess
    //               );
    //           }}
    //         />
    //       </li>
    //       <li>
    //         <img
    //           src={NewSlideRightArrowIcon}
    //           className={
    //             lastChild(currentSlide) ? "down-arrow-disabled" : "down-arrow"
    //           }
    //           style={{ cursor: "pointer" }}
    //           alt=""
    //           onClick={() => {
    //             !lastChild(currentSlide) &&
    //               navigateToNextChildAndFromParent(
    //                 currentSlide,
    //                 setCurrentSlide,
    //                 setChildSlideCount,
    //                 setSlideCount,
    //                 editor,
    //                 navigate,
    //                 slideID,
    //                 setSlideID,
    //                 inputElement,
    //                 setcanvasWidth,
    //                 setLoadSuccess,
    //                 setSaveLoading,
    //                 loadSuccess
    //               );
    //           }}
    //         />
    //       </li>
    //     </ul>
    //   </div>
    //   {/* {JSON.stringify(currentSlide.child) === "{}" && (
    //     <div className="new-slide bottom">
    //       <ul className="d-flex">
    //         <li
    //           className=""
    //           style={{ cursor: "pointer" }}
    //           onClick={() =>
    //             addNewChildSlide(
    //               slideID,
    //               setSlideID,
    //               currentSlide,
    //               setCurrentSlide,
    //               editor,
    //               appData,
    //               createNewChildSlide,
    //               toast,
    //               slideCount,
    //               createNewPage,
    //               childSlideCount,
    //               setChildSlideCount,
    //               AddMasterSlideToDeck,
    //               navigate
    //             )
    //           }
    //         >
    //           Sub Slide
    //         </li>
    //         <li>
    //           <img
    //             src={NewSlideAddDocumentIcon}
    //             alt=""
    //             style={{ cursor: "pointer" }}
    //           />
    //         </li>
    //         <li>
    //           <img
    //             src={NewSlideGroupIcon}
    //             style={{ cursor: "pointer" }}
    //             alt=""
    //           />
    //         </li>
    //       </ul>
    //     </div>
    //   )} */}
    // </div>
  );
};

export default SlideIndex;
